import { useState, useEffect } from 'react';
import { getUserLanguage } from '@/api/language';
import { translations, Language, TranslationKey } from '@/utils/translations';

export const useTranslation = () => {
  const [language, setLanguage] = useState<Language>('fi');

  useEffect(() => {
    const fetchUserLanguage = async () => {
      try {
        if (localStorage.getItem('language')) {
          const storedLanguage = localStorage.getItem('language') as Language;
          setLanguage(storedLanguage);
          return;
        }
        const response = await getUserLanguage();
        if (response && response.language) {
          setLanguage(response.language as Language);
          localStorage.setItem('language', response.language);
        }
      } catch (error) {
        console.error('Error fetching user language:', error);
      }
    };

    fetchUserLanguage();
  }, []);

  const t = (key: TranslationKey): string => {
    // Direct lookup first (for keys that might contain dots)
    if (key in translations) {
      const translationObj = translations[key as keyof typeof translations];
      if (translationObj && language in translationObj) {
        return translationObj[language as keyof typeof translationObj] || key;
      }
    }

    // Fallback to the key itself if translation is missing
    console.warn(`Translation missing for key: ${key}`);
    return key;
  };

  return { t, language, setLanguage };
};